import { render } from "./ProductItem.vue?vue&type=template&id=c19b4b5e&scoped=true"
import script from "./ProductItem.vue?vue&type=script&lang=js"
export * from "./ProductItem.vue?vue&type=script&lang=js"

import "./ProductItem.vue?vue&type=style&index=0&id=c19b4b5e&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-c19b4b5e"

export default script